import script from "./AddBranch.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBranch.vue?vue&type=script&setup=true&lang=js"

import "./AddBranch.vue?vue&type=style&index=0&id=d3f9428e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f9428e"]])

export default __exports__